import Vue from 'vue'
import Vuex from 'vuex'

/*
let base_url = "http://www.newbalajirecharge.com/ReCharge/androidapi.asmx/";
let rbase_url = "http://www.newbalajirecharge.com/ReCharge/APIs.aspx";
let sbase_url = "http://www.newbalajirecharge.com/ReCharge/APIAndroid.aspx";
*/

let base_url = "http://direct.mrechargesystem.com/ReCharge/androidapi.asmx/";
let rbase_url = "http://direct.mrechargesystem.com/ReCharge/APIs.aspx";
let sbase_url = "http://direct.mrechargesystem.com/ReCharge/APIAndroid.aspx";
/*
let base_url = "http://gayatrirecharge.in/ReCharge/androidapi.asmx/";
let rbase_url = "http://gayatrirecharge.in/ReCharge/APIs.aspx";
let sbase_url = "http://gayatrirecharge.in/ReCharge/APIAndroid.aspx";
*/
let path = 'http://free.mrechargesystem.com/ReCharge/UploadImages/';
//let path = 'http://gayatrirecharge.in/ReCharge/UploadImages/';

let apikey = '95a0ff4dbf948055288f75381f548cd7';
let details = {
              "AndroidAppName":"Balaji Online Recharge",
              "PlayStoreUrl":" https://play.google.com/store/apps/details?id=com.balajinew.mobrecharge",
              "EmailId":"balajirecharge38@gmail.com",
              "ServerNo":"xxx",
              "HelpLineNo":"91 9909113306",
              "Address1":"A-801, Samudra Complex, Near Klassic Gold Hotel, ",
              "Address2":"Off C.G.Road, Ahmedabad, Gujarat, India.",
              "ContactName":"Httreds",
              "ContactMob":"91 9909113306",
              "Footer":"http://www.newbalajirecharge.com",
              "InqueryNumber":"91 7016231669"
            }
let bankdetails = [{"Id":1,
                  "BankName":"Central Bank Of India",
                  "CompanyName":"COMMUNICATION POINET",
                  "AcountNo":"3629330332",
                  "Branch":"RAJKOT",
                  "IfscCode":"CBIN0282905",
                  "UserDomainName":null,
                  "CreatedBy":0,
                  "IconImage":"SBI.jpg"},
                  {"Id":1,
                  "BankName":"ICICI BANK",
                  "CompanyName":"A A TRADING CO",
                  "AcountNo":"136805500618",
                  "Branch":"RAJKOT",
                  "IfscCode":"ICIC0001368",
                  "UserDomainName":null,
                  "CreatedBy":0,
                  "IconImage":"SBI.jpg"},
                  
                  ]
let image = require("./assets/logob.png")
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    _rwidth:window.innerWidth-310-303+"px",
    _user:[],
    _profile:[],
    _details:details,
    _bankdetails:bankdetails,
    _logo:image,
    _lasttrans:[],
    _operator:[],
    _path:path,
    _clear:"",
    _balance:"",
    _statelist:[],
    _citylist:[],
    _bank:[],
    _quickpay:[]
  },
  getters:{
    bankdetails(state){
      return state._bankdetails
    },
    details(state){
      return state._details
    },
    logo(state){
      return state._logo
    },
    rwidth(state){
      return state._rwidth
    },
    path(state){
      return state._path
    },
    statelist(state){
      return state._statelist
    },
    citylist(state){
      return state._citylist
    },
    profile(state){
      return state._profile;
    },
    operator(state){
      return state._operator;
    },
    lasttrans(state){
      return state._lasttrans;
    },
    user(state){
      return state._user;
    },
    clear(state){
      return state._clear;
    },
    balance(state){
      return state._balance;
    },
    bank(state){
      return state._bank;
    },
    quickpay(state){
      return state._quickpay;
    }
  },
  mutations: {
    setrwidth(state,value){
      state._rwidth = value
    },
    setuser(state,value){
      state._user = value
    },
    setstatelist(state,value){
      state._statelist = value
    },
    setcitylist(state,value){
      state._citylist = value
    },
    setoperator(state,value){
      state._operator = value
    },
    setprofile(state,value){
      state._profile = value
    },
    setlasttrans(state,value){
      state._lasttrans = value
    },
    setclear(state,value){
      state._clear = value
    },
    setbalance(state,value){
      state._balance = value.Data.Balance
    },
    setbank(state,value){
      state._bank = value.Data
    },
    setquickpay(state,value){
      state._quickpay = value
    },
    setdetails(state,value){
      if(value.details!=null){
        state._details = value.details        
      }
      if(value.logo!=null){
        state._logo = path +value.logo       
      }
      if(value.bankdetails!=null){
        state._bankdetails = value.bankdetails        
      }
    },
  },
  actions: {
    axiosget(context,payload){
      let url    = base_url + payload.url;
      let params = payload.data;
      let way = payload.way;
      return new Promise((resolve, reject) => {
        Vue.axios.get(url,{params:params}).then(function (docs) {
          if(docs.data.Message=="Not Authorised.") {
            window.localStorage.removeItem("user");
            context.dispatch("getuser");
            return resolve(docs)
          }
          if(docs.data)context.commit(way,docs.data)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    getbalance(context){
      let user =context.getters.user
      if(user!=null&& user.length!=0){
        let doc  = {PinNo:user.pin,MobileNo:user.phone};
        context.dispatch("axiosget",{data:doc,url:"Balance",way:"setbalance"});
      }
    },

    setsync(context,payload){
      context.commit("setquickpay",payload.data)
    },

    getuser(context){
      let doc = [];
      if(localStorage.user){
        doc = JSON.parse(localStorage.user);
      }
      if(doc!=null) context.commit("setuser",doc);
    },
    axios(context,payload){
      let url    = base_url + payload.url;
      let params = payload.data;
      return new Promise((resolve, reject) => {
        Vue.axios.get(url,{params:params}).then(function (docs) {
          if(docs.data.Message=="Not Authorised.") {
            window.localStorage.removeItem("user");
            context.dispatch("getuser");
            return resolve(docs)
          }
          resolve(docs)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    raxios(context,payload){
      let params = payload.data;
      let url    = rbase_url+params;
      return new Promise((resolve, reject) => {
        Vue.axios.get(url).then(function (docs) {
          if(docs.data.Message=="Not Authorised.") {
            window.localStorage.removeItem("user");
            context.dispatch("getuser");
            return resolve(docs)
          }
          resolve(docs)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    saxios(context,payload){
      let params = payload.data;
      let url    = sbase_url+params;
      return new Promise((resolve, reject) => {
        Vue.axios.get(url).then(function (docs) {
          if(docs.data.Message=="Not Authorised.") {
            window.localStorage.removeItem("user");
            context.dispatch("getuser");
            return resolve(docs)
          }
          resolve(docs)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    notify(context,payload){
      let vm = payload.vm;
      let message = payload.message;
      let type = payload.type;
      vm.$notify({
              group: 'foo',
              title: 'Important message',
              text: message,
              duration:5000,
              type:type
      })
    },
    planapi(context,payload){
      let url    = "http://submplan.payclick.co.in/MPLAN/Services/API.asmx/" + payload.url;
      let params ={
        url:'apikey='+apikey+'|'+payload.data
      }
      return new Promise((resolve, reject) => {
        Vue.axios.get(url,{params:params}).then(function (docs) {
          if(docs.data.Message=="Not Authorised.") {
            window.localStorage.removeItem("user");
            context.dispatch("getuser");
            return resolve(docs)
          }
          resolve(docs)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    /*

        operator(context,payload){
         let params = payload.data;
         let url = base_url+"ServiceInUseList"
         return new Promise((resolve, reject) => {
           Vue.axios.get(url,{params:params}).then(function (docs) {
             if(docs.data.Message=="Not Authorised.") {
               window.localStorage.removeItem("user");
               context.dispatch("getuser");
               return resolve(docs)
             }

             if(docs.data)context.commit("setoperator",docs.data.Data)
           }).catch(function (error) {
             reject(error)
           })
         })
       }
*/
     //for free recharge
       operator(context,payload){
         let params = payload.data;
         let url = "http://free.mrechargesystem.com/ReCharge/androidapi.asmx/ServiceInUseList"
         return new Promise((resolve, reject) => {
           Vue.axios.get(url,{params:params}).then(function (docs) {
             if(docs.data.Message=="Not Authorised.") {
               window.localStorage.removeItem("user");
               context.dispatch("getuser");
               return resolve(docs)
             }
             if(docs.data)context.commit("setoperator",docs.data.Data)
           }).catch(function (error) {
             reject(error)
           })
         })
     }

  }


})
